import React, { useEffect } from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ReclamoCreationContent } from './components/ReclamoCreationContent';
import { useNavigate, useParams } from 'react-router-dom';

export default function ReclamoCreation() {
    const navigate = useNavigate();
    const { tipoGestion } = useParams();

    useEffect(() => {
        if (!tipoGestion || (tipoGestion !== 'efi' && tipoGestion !== 'reclamos')) { //Valido que la URL sea correcta
            navigate('/menu', { replace: true });
        }
    }, [tipoGestion]);

    return (
        <MainContent
            component={<ReclamoCreationContent />}
            titulo={tipoGestion === 'efi' ? 'Nuevo EFI' : 'Nuevo Reclamo'}
            noBackground
            tableMaxWidth
        />
    );

};
